import React, { useState } from "react"
import * as styles from "./SwipeGallery.module.css"
import classNames from "classnames"
import useDeviceType from "../../../../hooks/useDeviceType"

type SwipeGalleryProps = {
  children: React.ReactElement
}

const SwipeGallery = ({ children }: SwipeGalleryProps) => {
  const [activePage, setActivePage] = useState(0)
  const [startX, setStartX] = useState(0)

  const DeviceType = useDeviceType()

  const gallerys =
    React.Children.count(children) === 1
      ? children.props.children
      : React.Children.toArray(children)

  // Touch Start
  const handleTouchStart: React.TouchEventHandler<HTMLDivElement> = e => {
    setStartX(e.touches[0].clientX)
  }

  // Touch End
  const handleTouchEnd: React.TouchEventHandler<HTMLDivElement> = e => {
    const currentX = e.changedTouches[0].clientX
    if (activePage > 0 && currentX > startX) {
      // Pre Page
      setActivePage(preActivePage => preActivePage - 1)
    } else if (activePage < gallerys.length - 1 && currentX < startX) {
      // Next Page
      setActivePage(preActivePage => preActivePage + 1)
    }
    setStartX(0)
  }

  if (DeviceType !== "mobile" && DeviceType !== "tablet") return children
  return (
    <div
      className={classNames({ [styles.touchStart]: startX })}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {gallerys[activePage]}

      {/* Pages Circle */}
      <div className={styles.sliderCircleContent}>
        {gallerys.map((_: any, index: number) => (
          <div
            key={index}
            className={classNames(styles.circle, {
              [styles.active]: activePage === index,
            })}
            onClick={() => setActivePage(index)}
          />
        ))}
      </div>
    </div>
  )
}

export default SwipeGallery
